
<div class=" pb-2" style="padding-top: 2px;">
    <f-currency-field
        v-model         = "amount.net"
        :rules          = "[netAmountRule]"
        class           = "money"
        :label          = "label"
        :error-messages = "netamountError"
    />

    <v-switch
        v-if            = "hasCalculation && !showCosts"
        v-model         = "item.acceptDifference"
        class           = "mt-2 pt-0"
        label           = "Differenz akzeptiert"
        :ripple         = "false"
        @change         = "validate()"
        hide-details
        :style="showCosts ? '' : 'margin-bottom: 26px;'"
    />

    <div
        v-if            = "spacer"
        class           = "mt-9"
    />

    <f-currency-field
        v-if="showCosts"
        class           = "money"
        :label          = "$t('invoice.cost.material')"
        v-model         = "amount.costMaterial"
        :rules          = "[costsEqualNetAmountRule]"
        :error-messages = "costMaterialError"
        :hide-details   = "false"
        ref="material"
    />

    <f-currency-field
        v-if="showCosts"
        v-model         = "amount.costWage"
        class           = "money pb-2"
        :label          = "$t('invoice.cost.wage')"
        :rules          = "[costsEqualNetAmountRule]"
        :error-messages = "costWageError"
        :hide-details   = "true"
        ref="wage"
    />
</div>
